export var Idempotence;
(function (Idempotence) {
    /**The operation will not fail if the entity already exists in a different and compatible form.*/
    Idempotence["IGNORE_DIFFERENT"] = "IGNORE_DIFFERENT";
    /**The operation will fail if the entity already exists*/
    Idempotence["FAIL_IF_EXISTING"] = "FAIL_IF_EXISTING";
    /**The operation will not fail if the entity already exists in a similar form.*/
    Idempotence["IGNORE_IDENTICAL"] = "IGNORE_IDENTICAL";
})(Idempotence || (Idempotence = {}));
export var PageDirection;
(function (PageDirection) {
    /**Descending order*/
    PageDirection["DESC"] = "DESC";
    /**Ascending order*/
    PageDirection["ASC"] = "ASC";
})(PageDirection || (PageDirection = {}));
export var FileType;
(function (FileType) {
    /**Normal file*/
    FileType["FILE"] = "FILE";
    /**Directory. May contain other files.*/
    FileType["DIR"] = "DIR";
})(FileType || (FileType = {}));
//# sourceMappingURL=CommonTypes.js.map